export default __webpack_public_path__ + "static/proj4-8d4aed88ba2431c6b8e222a0c4f519a3.jpg";